/**
 * 异常待处理订单
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2021, all rights reserved. Essa.cn
 */
import React from 'react';
import {Button, Card, Col, Row, Spin,} from "antd";
import {Link} from "react-router-dom";
import Lang from "@components/Lang/Lang";
import AutoFetchList from '@components/AutoFetchList/AutoFetchList';
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import dayjs from "dayjs";
import {isEmpty } from '@utils/utils';
import Locale from "@utils/locale";
import "./ExceptionPendingOrder.less";

class ExceptionPendingOrder extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            searchFormOptions:[
                {
                    name:'keyword',
                    cnTitle:'采购商',
                    cnTitleId:'CaiGouShang',
                    cnPlaceholder:'请输入采购商编码或名称',
                    cnPlaceholderId:'QingShuRuCaiGouShangBianMaHuoMingCheng'
                },
                {
                    name:'poCode',
                    cnTitle:'订单号',
                    cnTitleId:'DingDanHao',
                    cnPlaceholder:'请输入订单号',
                    cnPlaceholderId:'QingShuRuDingDanHao'
                }
            ],
            abnormalTakeTimeSort:'',
            loading:false,
        }
    }
    /**
     * 列表
     * */
    renderList=(item,index)=>{
                return <Card className="mb_16" key={item.buyerId}>
                    <div className="mb_16" data-flex="main:justify">
                        <p className="font_15 title-black font-weight-700">{Lang({id: 'KeHu', default: '客户'})}<span>{item.buyerCode}</span></p>
                    </div>
                    {this.getSon(item.poAbnormalVOList)}
                </Card>
    }
    getSon(poList=[]){
        let children = [];
        poList.forEach(item=>{
            children.push(<div className={'list-son-order-item'} key={item.containerId}>
                <Row>
                    <div className={"font_13 title-black"}> {Lang({id: 'DingDan', default: '订单'})}<span>{item.poCode}</span></div>
                    <div className="font_13 title-grey">{Lang({id: 'XiaDanRen', default: '下单人'})}<span>{item.buyerName}</span><span>{item.buyerEmail}</span>{item.mobile&&<span>+{item.telCode} {item.mobile}</span>}</div>
                </Row>
                <Row className={'info-box'} gutter={24}>
                    <Col span={16}>
                        <div className="font_13 row-grey">
                            <Row gutter={24}>
                                <Col span={10}>
                                    <div>{Lang({id: 'XiaDanShiJian', default: '下单时间'})}<span>{item.orderTime?dayjs(item.orderTime).format('YYYY-MM-DD'):'-'}</span></div>
                                    <div>{Lang({id: 'YuanShiYuJiDaoGangShiJian', default: '原预计到达时间'})}<span>{item.arrivalPortDate?dayjs(item.arrivalPortDate).format('YYYY-MM-DD'):'-'}</span></div>
                                </Col>
                                <Col span={Locale.current()=='ru'?4:6}>
                                    <div>{Lang({id: 'XiangShu', default: '箱数'})}<span>{item.quantity||"-"}</span></div>
                                    <div> {Lang({id: 'KuanShu', default: '款数'})}<span>{item.skuNum||"-"}</span></div>
                                </Col>
                                <Col span={Locale.current()=='ru'?10:8}>
                                    <div>{Lang({id: 'YiChangShiJian', default: '异常时间'})}<span>{item.abnormalTime?dayjs(item.abnormalTime).format('YYYY-MM-DD'):'-'}</span></div>
                                    <div>{Lang({id: 'YiChangHaoShi', default: '异常耗时'})}{this.formatSeconds(item.abnormalTakeTime)}</div>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                    <Col span={8}>
                        <div className={'right'}>
                            <div className={'right-num-info font_13'}>{Lang({id: 'YiChangShangPinShu', default: '异常商品数'})}<span>{item.abnormalNum||0}</span></div>
                            <Link className="link" to={
                                {
                                    pathname: '/order/exceptionPendingOrder/detail',
                                    search: `?${item.containerId}`,
                                }
                            }>
                                <Button shape="round" size={'large'}>{Lang({id: 'ChaKanYiChang', default: '查看异常'})}</Button>
                            </Link>
                        </div>
                    </Col>
                </Row>
            </div>)
        })
        return children
    }
    formatSeconds(value) {
        let over24Hour = false;
        let theTime = parseInt(value);// 秒 
        let middle= 0;// 分
        let hour= 0;// 小时
        let result = "";
        if(theTime > 60) {
            middle= parseInt(theTime/60);
            if(middle> 60) {
                hour= parseInt(middle/60);
                middle= parseInt(middle%60);
            }
            if(middle > 0) {
                result = middle + Lang({id: 'Fen', default: '分'});
            }
            if(hour> 0) {
                if(hour>=24) over24Hour = true;
                result = hour +Lang({id: 'XiaoShi', default: '小时'})+' '+result;
            }
        }else result = 1 + Lang({id: 'Fen', default: '分'});
 
        return over24Hour?<span className={'span-red'}>{result}</span>:<span>{result}</span>;
    }
    changeSort(sort){
        this.setState({
            abnormalTakeTimeSort:sort
        },()=>this.onRefAutoFetchListChrld.handleFetch(1,true))

    }
    onRefAutoFetchList = (ref) =>  this.onRefAutoFetchListChrld = ref;
    searchReset(){
        this.setState({
            abnormalTakeTimeSort:''
        },()=>this.onRefAutoFetchListChrld.handleFetch(1,false))
    }
    componentDidMount() {
    }
    render(){
        const { loading,searchFormOptions,abnormalTakeTimeSort} = this.state;
        const currPageName =  Lang({id: "YiChangDaiChuLiDingDan",default: "异常待处理订单"});
        return ( <Spin spinning={loading}>
            <CommonBreadcrumb list={[{name:currPageName}]}></CommonBreadcrumb>
            <div className="exceptionPendingOrder" style={{minWidth:'1200px'}}>
                    <div className={'title font_18 fw_700'}>{Lang({id: "YiChangDaiChuLiDingDan", default: "异常待处理订单"})}</div>
                    <div className={'exception-pending-order-list-wrap'}>
                        <AutoFetchList onRef={this.onRefAutoFetchList}
                            searchFormOptions={searchFormOptions}
                            topSearchRightCont={<div className={'topSort'} onClick={()=>this.changeSort(abnormalTakeTimeSort=='ASC'?'DESC':'ASC')}>
                                {Lang({id: "YiChangHaoShiPaiXu",default: "异常耗时排序"})}
                                <i className={"iconfont icon-arrow-down down"+(abnormalTakeTimeSort=='DESC'?' on':'')} />
                                <i className={"iconfont icon-packup up"+(abnormalTakeTimeSort=='ASC'?' on':'')} />
                                </div>}
                            precondition={isEmpty(abnormalTakeTimeSort)?{abnormalTakeTimeSort:'DESC'}:{abnormalTakeTimeSort:abnormalTakeTimeSort}}
                            fetchApi={'/service/mg/po/abnormal-list'}
                            searchReset={()=>this.searchReset()}
                            renderList={this.renderList}
                        />
                    </div>
            </div>
        </Spin> )
    }
}
export default ExceptionPendingOrder;
